import ButtonGroup from "../../forms/buttonGroup/ButtonGroup";
import {WritingIcon} from "../../../assets/icons/WritingIcon";
import {LightningIcon} from "../../../assets/icons/LightningIcon";
import React from "react";
import {Button} from "antd";
import {RoundFullCheckIcon} from "../../../assets/icons/RoundFullCheckIcon";
import ReviewWarning from "../../reviewWarning/ReviewWarning";

interface NewFlowStep2Props {
    templatesCount: number;
    onTemplateBuildingWaySelect: (wayId: number | string) => void;
    completeFlow: () => void;
}

const NewFlowStep2 = ({ templatesCount, onTemplateBuildingWaySelect, completeFlow }: NewFlowStep2Props) => {
    const getTitle = () => {
        if(templatesCount > 0 && templatesCount < 5) {
            return "Looking good so far, Would you like to add another template or finish up?"
        } else if(!templatesCount) {
            return 'Great work, Now let’s create the templates to bring your flow to life';
        } else {
            return 'Nice work! Your flow is ready with 5 templates.';
        }
    }

    const getDescription = () => {
        if(!templatesCount) {
            return 'Templates define the messages and timing for your flow. They determine what gets sent to customers and when, helping you automate communication effectively.';
        } else {
            return '';
        }
    }

    return (
        <div className={`templates-intro ${templatesCount ? '' : 'first'}`}>
            <div className="title">{getTitle()}</div>
            <div className="sub-title">{getDescription()}</div>
            <ReviewWarning />
            <div className="template-creation-options">
                {templatesCount < 5 ? <ButtonGroup
                    items={[{
                        id: 1,
                        title: templatesCount ? "Build Another Template" : "Build from Scratch",
                        description: "Add templates one by one, customizing each message and timing to fit your needs.",
                        icon: <WritingIcon width={48} color='#000' />,
                        isSelected: false
                    }, ...(templatesCount ? [] : [{
                        id: 2,
                        title: "Build with Our Wizard",
                        description: "Generate a set of templates instantly by selecting a type and size, then edit as needed.",
                        icon: <LightningIcon width={48} color='#000' />,
                        isSelected: false
                    }])]}
                    onClick={(newId: number | string) => {
                        onTemplateBuildingWaySelect(newId);
                    }}
                    descriptionAlwaysOn={true}
                /> : null}
                {templatesCount ? <div className={`complete-flow-container ${templatesCount === 5 ? 'single-option' : ''}`}>
                    <div className="description">Or complete the creation of your flow with {templatesCount} templates.</div>
                    <Button size="large" type="primary" icon={<RoundFullCheckIcon width={20} color="#fff" />} onClick={completeFlow}>Complete Flow</Button>
                </div> : null}
            </div>
        </div>
    )
}

export default NewFlowStep2;